type ChunkFetchArgs = {
  skip: number;
  limit: number;
};

type FetchChunkFn<T> = (args: ChunkFetchArgs) => Promise<T[]>;

export async function loadChunkedDataUntilDone<T>(
  chunkSize: number,
  fetchChunk: FetchChunkFn<T>
): Promise<T[]> {
  const result: T[] = [];
  let skip = 0;
  let currentChunkSize = 0;

  do {
    const chunk = await fetchChunk({ skip, limit: chunkSize });
    result.push(...chunk);

    currentChunkSize = chunk.length;
    skip += chunkSize;
  } while (currentChunkSize === chunkSize);

  return result;
}
